// types
import {SaleOrderStatusActionTypes, SaleOrderStatusState, SaleOrderStatusType} from "./types";

export const NewSaleOrderStatusItem:SaleOrderStatusType = {
  enabled: true,
  name: '',
  order: 500
}

export const INIT_STATE_SALE_ORDER_STATUS: SaleOrderStatusState = {
  items: [],
  rightModalShow: false,
  removeModalShow: false,
  selectedItem: NewSaleOrderStatusItem,
  modalEditTitle: '',
  isSending: false,
  isFetched: false,
  isLoading: false,
  isNeedReload: false
};

const SaleOrderStatus = (state = INIT_STATE_SALE_ORDER_STATUS, action: any) => {
  switch (action.type) {
    case SaleOrderStatusActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case SaleOrderStatusActionTypes.GET_SALE_ORDER_STATUSES:
          return {
            ...state,
            items: action.payload.data.items,
            meta: action.payload.data.meta,
            isFetched: true,
            isLoading: false,
            isNeedReload: false
          };
        case SaleOrderStatusActionTypes.UPDATE_SALE_ORDER_STATUS:
          return {
            ...state,
            selectedItem: NewSaleOrderStatusItem,
            rightModalShow: false,
            isSending: false,
            isNeedReload: true
          };
        case SaleOrderStatusActionTypes.REMOVE_SALE_ORDER_STATUS:
          return {
            ...state,
            selectedItem: NewSaleOrderStatusItem,
            removeModalShow: false,
            isNeedReload: true
          };
        default:
          return { ...state };
      }

    case SaleOrderStatusActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case SaleOrderStatusActionTypes.GET_SALE_ORDER_STATUSES:
          return {
            ...state,
            isFetched: false,
            isLoading: false,
            isNeedReload: false
          };
        case SaleOrderStatusActionTypes.UPDATE_SALE_ORDER_STATUS:
          return {
            ...state,
            isSending: false
          };
        case SaleOrderStatusActionTypes.REMOVE_SALE_ORDER_STATUS:
          return {
            ...state,
            removeModalShow: false
          };
        default:
          return { ...state };
      }
    case SaleOrderStatusActionTypes.EDIT_SALE_ORDER_STATUS:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case SaleOrderStatusActionTypes.RIGHT_MODAL_SHOW:
      return {
        ...state,
        selectedItem: NewSaleOrderStatusItem,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case SaleOrderStatusActionTypes.REMOVE_SALE_ORDER_STATUS_MODAL_SHOW:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        removeModalShow: true
      }
    case SaleOrderStatusActionTypes.REMOVE_SALE_ORDER_STATUS_MODAL_HIDE:
      return {
        ...state,
        selectedItem: NewSaleOrderStatusItem,
        removeModalShow: false
      }
    case SaleOrderStatusActionTypes.RIGHT_MODAL_HIDE:
      return {
        ...state,
        rightModalShow: false
      }
    case SaleOrderStatusActionTypes.UPDATE_SALE_ORDER_STATUS:
      return {
        ...state,
        isSending: true
      };
    case SaleOrderStatusActionTypes.GET_SALE_ORDER_STATUSES:
      return {
        ...state,
        isLoading: true
      };
    default:
      return { ...state };
  }
};

export default SaleOrderStatus;
